import { EMPTY_TEXT } from "../../common";
import { INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_REQUEST, INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_SUCCESS } from '../actions';
export const photoCaptureIntelligentEstimatorSummarySubmitReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isLoading: true, isEstimatorSummarySubmitSuccess: false });
        }
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_SUCCESS: {
            const response = action.payload.response;
            const isSuccess = response.message !== EMPTY_TEXT;
            return Object.assign(Object.assign({}, state), { isLoading: false, isEstimatorSummarySubmitSuccess: isSuccess });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentEstimatorSummarySubmitReducer.js.map